import React, { memo, useState, useEffect, useRef, FC } from 'react';
import * as eCharts from 'echarts';
import { lineTooltipFormatter } from '../Retention/linechart';
import { useIntl, getLocale } from 'umi';

interface BreakDownBarProps {
  title: string;
  className?: string;
  data: any[];
  color?: string[];
  position?: any[];
}

const BreakDownBar: FC<BreakDownBarProps> = (props) => {
  const { title, className = '', data = [], color, position } = props;
  let myChart: any = null;
  const chartRef = useRef(null);
  const [options, setOptions] = useState<any>();
  const { formatMessage } = useIntl();
  const locale = getLocale();
  useEffect(() => {
    const list = data?.map((item) => {
      return {
        name: `${locale === 'zh-CN'? item.name_zh: item.name }(${(item?.dod * 100)?.toFixed(2)}%)`,
        type: 'bar',
        stack: 'total',
        barMaxWidth: 20,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 0.5,
          borderType: 'solid',
        },
        data: [
          {
            name: `${locale === 'zh-CN'? item.name_zh: item.name}(${(item?.dod * 100)?.toFixed(2)}%)`,
            name_zh: item.name_zh,
            name_en: item.name,
            value: item.dod,
            // color: item.color,
          },
        ],
      };
    });
    const colorConfig = color ? { color } : {};
    const regionOptions = {
      textStyle: {
        fontSize: 14,
      },
      grid: {
        x: '-0.5px',
        y: '0%',
        x2: '0%',
        y2: '0%',
        bottom: 20,
        containLabel: true,
      },
      legend: {
        show: true,
        icon: 'circle',
        type: 'scroll',
        selectedMode: true,
        textStyle: {
          fontSize: 12,
          color: '#888',
        },
        pageIconSize: 10,
        pageTextStyle: {
          color: '#707070',
        },
        left: -7,
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 20,
        bottom: -4,
      },
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        extraCssText: 'border: none;',
        padding: 0,
        trigger: 'axis',
        // confine: true,
        showDelay: 0,
        hideDelay: 0,
        position: position ? position : [],
        transitionDuration: 0.2,
        // enterable: false,
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: 'rgba(216, 218, 228, 0.5)',
            type: 'solid',
            width: 40,
          },
        },
        formatter: (param: any[]) => {
          const list = param?.map((item) => {
            return {
              ...item,
              seriesName:
                locale === 'zh-CN' ? item?.data?.name_zh : item?.data?.name_en,
            };
          });
          return lineTooltipFormatter(
            list?.sort((a, b) => b?.value - a?.value),
            title,
            '',
            (value: any) => `${(value * 100)?.toFixed(2)}%`,
          );
        },
        textStyle: {
          fontSize: 14,
        },
      },
      xAxis: {
        show: false,
        type: 'value',
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        show: false,
        type: 'category',
        data: ['Global'],
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: list,
      ...colorConfig,
    };

    setOptions(regionOptions);
  }, [locale, data]);

  useEffect(() => {
    if (chartRef?.current) {
      if (myChart === null) {
        myChart = eCharts.init(chartRef!.current!);
      }
      options && myChart.setOption(options, true);
    } else {
      if (myChart) {
        myChart.dispose();
      }
    }
  }, [options]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myChart]);

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };

  return (
    <div className={`break-down-chart-container ${className}`}>
      <div className="break-down-chart-container-title">{title}</div>
      {data?.length > 0 ? (
        <div style={{ height: 60 }} ref={chartRef}></div>
      ) : null}
      {!data?.length && (
        <div className="revenue-nodata-container breakdown-no-data">
          {formatMessage({ id: 'dbi_detail_no_data_under' })}
        </div>
      )}
    </div>
  );
};

BreakDownBar.defaultProps = {};

export default memo(BreakDownBar);
